import $ from 'jquery';

function initSlider() {
    $('.js-partners-slider').slick({
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 1600,
            settings: {
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
           }
        },
        {
            breakpoint: 1024,
            settings: {
                dots: false,
                slidesToShow: 2.8,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
           }
        },
        {
            breakpoint: 520,
            settings: {
                dots: false,
                slidesToShow: 1.8,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
           }
        }
        ]
    });
}

$(document).ready(function() {
    initSlider();

    $(document).on('click', '.js-vi-button', function() {
        if ($('.b-vi-top-control').is(":hidden")) {
            $('.js-partners-slider').slick('destroy');
        } else {
            initSlider();
        }
    });
    $(document).on('click', '.b-vi-top-control__version', function() {
        initSlider();
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/partners-slider.js